import { AddNewController, EditController } from "../../../list-management/scripts/list-management.controllers";
import { AnimalModelsEditControllerConfig } from "./edit-animal-models.objects";
import { AnimalModelsTable } from "./edit-animal-models.table";
import { Section, SectionField } from "../../../list-management/scripts/list-management.form-sections";
import { JsonItem, AnimalModel } from "../../../list-management/scripts/list-management.objects";
import { getDisplayDate } from "../../../../shared/scripts/date-functions"
import _ from "lodash";

export class EditAnimalModelController {
    // Config variables
    submitRoute: string;
    modalIdTarget: string;
    isAdmin: boolean;
    tableVarName: string;
    parentTable: AnimalModelsTable;

    // Const Varaibles
    id: string;
    title: string;
    sections: Section[];
    displayPropertyName: string;
    referenceId: string = "am";

    editController: EditController;
    constructor(config: AnimalModelsEditControllerConfig, parent: AnimalModelsTable) {
        this.id = "animal-models-edit-controller";
        this.title = "Edit Animal Model";
        this.submitRoute = config.submitRoute;
        this.modalIdTarget = config.modalIdTarget;
        this.isAdmin = config.isAdmin;
        this.tableVarName = config.tableVarName;
        this.parentTable = parent;

        this.displayPropertyName = "ModelName";
        //unique id/ label/ type of input/ objectDb id/  is required/ optional:-> picklist optional/description (helper txt)
        this.sections = [
            new Section("edit-am-general-section", "General Information",
                [
                    new SectionField("edit-am-model-name", "Model Name", "input-lg", "ModelName", true, "", "Please include the virus, model species/strain."),
                    new SectionField("edit-am-purpose", "Model Purpose", "multi-dropdown-pl", "ModelPurposeIds", true, "pl-am-model-purpose"),
                    new SectionField("edit-am-champion", "Model Developer", "dropdown-pl-search", "ChampionId", true, "pl-user", "Primary point of contact for the animal model."),
                    new SectionField("edit-am-center", "Center", "dropdown-pl", "CenterId", true, "pl-center-limited"),
                    new SectionField("edit-am-core", "Core(s)", "filtered-multi-dropdown-pl", "CoreIds", false, "pl-core", "", [["edit-am-center", "CenterId"]], ["pl-all-cores", "Id"]),
                    new SectionField("edit-am-project", "Project(s)", "filtered-multi-dropdown-pl", "ProjectIds", false, "pl-project", "", [["edit-am-center", "CenterId"]], ["pl-all-projects", "Id"])
                ], "", "", false
            ),
            new Section("edit-am-status-section", "Model Status",
                [
                    new SectionField("edit-am-model-status", "Model Status", "dropdown-pl", "ModelStatusId", true, "pl-am-model-status"),
                ]
            ),
            new Section("edit-am-virus-section", "Virus Information",
                [
                    new SectionField("edit-am-virus-family", "Virus Family", "dropdown-pl-search", "VirusFamilyId", true, "pl-virus-family"),
                    new SectionField("edit-am-challenge-virus", "Challenge Viruses", "filtered-multi-dropdown-pl-search", "ChallengeVirusIds", true, "pl-virus", "", [["edit-am-virus-family", "FamilyId"]], ["all-viruses", "Id"]),
                    new SectionField("edit-am-virus-strain", "Virus Strain Details", "input-xl", "VirusStrainDetails", false, "", "Please include detailed virus strain/isolate and lineage descriptions."),
                    new SectionField("edit-am-virus-source", "Virus Source", "input-xl", "VirusSource", true, "", "Include detail on catalog number, Certificate of Analysis Availability, Provenance, etc."),
                    new SectionField("edit-am-virus-characterization", "Virus Characterization", "input-xl", "VirusCharacterization", true, "Process/assays used to characterize and ensure quality and consistency of the challenge virus stock."),
                    new SectionField("edit-am-virus-dose", "Virus Dose", "input-lg", "VirusDose", true, "", "Please specify the dose or dose range, and include appropriate units."),
                    new SectionField("edit-am-virus-route", "Virus Route", "multi-dropdown-pl", "VirusRouteIds", true, "pl-am-route")
                ], "", "", false
            ),
            new Section("edit-am-animal-section", "Animal Information",
                [
                    new SectionField("edit-am-species", "Animal Species", "dropdown-pl", "SpeciesId", true, "pl-am-species", "If the species does not appear in the list, please specify the species in the <span class='font-weight-500'>Additional Information</span> section."),
                    new SectionField("edit-am-strain", "Animal Strain", "multi-dropdown-pl", "StrainIds", true, "pl-am-strain", "If the strain does not appear in the list, please specify the strain in the <span class='font-weight-500'>Additional Information</span> section."),
                    new SectionField("edit-am-strain-details", "Animal Strain Details", "input-xl", "StrainDetails", false),
                    new SectionField("edit-am-animal-source", "Animal Source", "multi-dropdown-pl", "SourceIds", true, "pl-am-source", "If the source does not appear in the list, please specify the source in the <span class='font-weight-500'>Additional Information</span> section."),
                    new SectionField("edit-am-absl", "Animal Biosafety Level", "dropdown-pl", "AbslId", true, "pl-absl"),
                    new SectionField("edit-am-animal-sex", "Animal Sex", "multi-dropdown-pl", "SexIds", true, "pl-am-sex"),
                    new SectionField("edit-am-animal-age", "Animal Age Inclusion", "input-lg", "Age", false, "", "If applicable, indicate the age or age range."),
                    new SectionField("edit-am-animal-weight", "Animal Weight Inclusion", "input-lg", "Weight", false, "", "If applicable, indicate the weight or weight range."),
                    new SectionField("edit-am-endpoints", "Endpoint", "multi-dropdown-pl", "EndpointIds", true, "pl-am-endpoint"),
                    new SectionField("edit-am-endpoint-details", "Endpoint Details", "input-xl", "EndpointDetails", false),
                ], "", "", false
            ),
            new Section("edit-am-developer-section", "Additional Information",
                [
                    new SectionField("edit-am-positive-control", "Positive Control", "input-xl", "PositiveControl", false, "", "Describe any countermeasure positive control(s) used in this model and use parameters (route, dose and regimen, anticipated effects of the control)."),
                    new SectionField("edit-am-pmids", "Publications", "list-selection-number", "PublicationIds", false, "", "Specify the PubMedId number (ex: 12345678) of any existing publications."),
                    new SectionField("edit-am-protocol", "Protocol", "edit-file-upload", "Protocol", false, "", "Please upload a <u>PDF version</u> of the protocol document associated with this animal model (Max 1 File Upload).", [["am-uploads"]]),
                    new SectionField("edit-am-additional-info", "Additional Information", "input-xl", "AdditionalInfo", false),
                ], "", "", false, true
            )
        ]

        this.editController = new EditController(this.id, this.title, "", this.sections, this.modalIdTarget, this.displayPropertyName);
    }

    initialize(pickLists: JsonItem[], selectedItems: any[], selectedSectionId: string): void {
        this.editController.initialize(pickLists, selectedItems, selectedSectionId);

        // Update Modal Footer Button
        let modalContentTarget = $(`#${this.modalIdTarget}`);
        let htmlFooterContent = `<button class="greenbtn" type="button" onclick="page.${this.tableVarName}.saveEditModal()">Save & Close</button><span class="error-msg ml-5 text-danger font-weight-500" id="request-footer-error"></span>`;

        modalContentTarget.find(".modal-footer").empty().html(htmlFooterContent);
    }

    async save(): Promise<any> {
        if (this.editController.selectedSection.fields.some(field => field.specialCaseEntity != undefined)) {
            this.editController.updateChangeLog();
        }

        let result: any;
        try {
            result = await $.ajax(this.submitRoute, {
                method: "POST",
                headers: { "RequestVerificationToken": <string>$('input[name="__RequestVerificationToken"]').val() },
                data: { data: JSON.stringify(this.editController.updatedItems) }
            });

            if (this.editController.fileUploadFields.length > 0) {
                for (let i = 0; i < this.editController.fileUploadFields.length; i++) {
                    let fileUploadField = this.editController.fileUploadFields[i];
                    await fileUploadField.updateAttachments();
                }
            }
            return result;
        }
        catch (error) {
            alert("An error has occurred, please refresh the page and try again.");
            console.log(error);
        }
    }

    showLoading(isLoading: boolean) {
        if (isLoading) {
            this.showSaved(false);
            $("#edit-item-content").addClass("d-none");
            $("#request-item-saving").removeClass("d-none");
        }
        else {
            $("#edit-item-content").removeClass("d-none");
            $("#request-item-saving").addClass("d-none");
        }
    }

    showSaved(isSaved: boolean) {
        if (isSaved) {
            $("#request-save-complete-block").removeClass("d-none");
            $("#request-save-in-progress-block").addClass("d-none");
        }
        else {
            $("#request-save-complete-block").addClass("d-none");
            $("#request-save-in-progress-block").removeClass("d-none");
        }
    }

    validateChanged(): boolean {
        let notChangedMessage = "";

        this.editController.selectedSection.fields.forEach(field => {
            if (!field.checkChanged()) {
                notChangedMessage = "Please update the animal model information."
            }
        });

        let errorMsgTarget = $("#request-footer-error")
        errorMsgTarget.text(notChangedMessage);

        if (notChangedMessage == "") {
            return true;
        }
        else {
            return false;
        }
    }

    getSelectedFilterTabId(): string {
        let selectedTab = $(`#${this.referenceId}-filter-tabs`).find(".active").first();
        return selectedTab.prop("id");
    }

    private additionalValidation(): boolean {
        let isValid: boolean = true;
        let errorBlock = $(`#${this.modalIdTarget}`).find("#request-footer-error");
        errorBlock.text("");

        let currentSection: Section = this.editController.selectedSection;
        if (currentSection.id == "edit-am-general-section") {
            let updatedAnimalModels: AnimalModel[] = this.editController.updatedItems;
            if (updatedAnimalModels.some(model => !model.ProjectIds && !model.CoreIds)) {
                let projectField = currentSection.fields.find(field => field.id == "edit-am-project");
                let coreField = currentSection.fields.find(field => field.id == "edit-am-core");
                errorBlock.text("Please specify at least one core or project for this Animal Model.");

                projectField.displayValid(false);
                coreField.displayValid(false);

                isValid = false;
            }
        }

        return isValid;
    }

    async saveEditModal(): Promise<void> {
        // if it isn't valid, don't save
        let isValid = this.editController.validate();
        if (!isValid) {
            return;
        }

        let additionalValidation = this.additionalValidation();
        if (!additionalValidation) {
            return;
        }
        else {
            // show saving on edit modal
            this.editController.showLoading(true);

            // Get Current Filter Options
            let selectedTab: string = this.getSelectedFilterTabId();
            let currentFilterOptions: any[][] = this.parentTable.filterTabs.map(tab => {
                return tab.getSelectedValues();
            });

            // Get Table Sort 
            let sortOrder: any[] = this.parentTable.getCurrentTableSort();

            // saves changes to DB (returns updated items)
            let result: any[] = await this.save();

            // reinitialze
            await this.parentTable.initialize()

            // Show Saved
            this.editController.showSaved(true);

            // Set Current Filter Options
            for (let i = 0; i < currentFilterOptions.length; i++) {
                let tabVals = currentFilterOptions[i];
                this.parentTable.filterTabs[i].setSelectedValues(tabVals);
            }
            $(`#${selectedTab}`).trigger("click");

            // Set Table Sort
            this.parentTable.setCurrentTableSort(sortOrder);

            // Scroll to Edited Item
            let editedItems: AnimalModel[] = this.editController.updatedItems;
            if (editedItems.length > 0) {
                let targetItem = editedItems[0];
                this.parentTable.scrollToAnimalModel(targetItem.Id);
            }

            // hide loading/close modal
            setTimeout(() => {
                $(`#${this.modalIdTarget}`).modal('hide');

                // Don't hide information until after modal finishes hiding
                setTimeout(() => {
                    this.editController.showLoading(false);
                    this.editController.showSaved(false);
                }, 1000)
            }, 1000)
        }
    }
}

export class AddAnimalModelController {
    // Config variables
    submitRoute: string;
    modalIdTarget: string;
    isAdmin: boolean;
    tableVarName: string;
    parentTable: AnimalModelsTable;

    // Const Varaibles
    id: string;
    title: string;
    sections: Section[];
    displayPropertyName: string;
    referenceId: string = "am";

    addController: AddNewController;
    constructor(config: AnimalModelsEditControllerConfig, parent: AnimalModelsTable) {
        this.id = "animal-model-add-controller";
        this.submitRoute = config.submitRoute;
        this.modalIdTarget = config.modalIdTarget;
        this.isAdmin = config.isAdmin;
        this.tableVarName = config.tableVarName;
        this.parentTable = parent;

        this.displayPropertyName = "ModelName";
        this.title = "Add Animal Model";

        this.sections = [
            new Section("am-general-section", "General Information",
                [
                    new SectionField("add-am-model-name", "Model Name", "input", "ModelName", true, "", "Please include the virus, model species/strain."),
                    new SectionField("add-am-purpose", "Model Purpose", "multi-dropdown-pl", "ModelPurposeIds", true, "pl-am-model-purpose"),
                    new SectionField("add-am-champion", "Model Developer", "dropdown-pl-search", "ChampionId", true, "pl-user", "Primary point of contact for the animal model."),
                    new SectionField("add-am-model-status", "Model Status", "dropdown-pl", "ModelStatusId", true, "pl-am-model-status"),
                    new SectionField("add-am-center", "Center", "dropdown-pl", "CenterId", true, "pl-center-limited"),
                    new SectionField("add-am-core", "Core(s)", "filtered-multi-dropdown-pl", "CoreIds", false, "pl-core", "", [["add-am-center", "CenterId"]], ["pl-all-cores", "Id"]),
                    new SectionField("add-am-project", "Project(s)", "filtered-multi-dropdown-pl", "ProjectIds", false, "pl-project", "", [["add-am-center", "CenterId"]], ["pl-all-projects", "Id"])
                ]
            ),
            new Section("am-virus-section", "Virus Information",
                [
                    new SectionField("add-am-virus-family", "Virus Family", "dropdown-pl-search", "VirusFamilyId", true, "pl-virus-family"),
                    new SectionField("add-am-challenge-virus", "Challenge Viruses", "filtered-multi-dropdown-pl-search", "ChallengeVirusIds", true, "pl-virus", "", [["add-am-virus-family", "FamilyId"]], ["all-viruses", "Id"]),
                    new SectionField("add-am-virus-strain", "Virus Strain Details", "input-lg", "VirusStrainDetails", false, "", "Please include detailed virus strain/isolate and lineage descriptions."),
                    new SectionField("add-am-virus-source", "Virus Source", "input-lg", "VirusSource", true, "", "Include detail on catalog number, Certificate of Analysis Availability, Provenance, etc."),
                    new SectionField("add-am-virus-characterization", "Virus Characterization", "input-lg", "VirusCharacterization", true, "Process/assays used to characterize and ensure quality and consistency of the challenge virus stock."),
                    new SectionField("add-am-virus-dose", "Virus Dose", "input", "VirusDose", true, "", "Please specify the dose or dose range, and include appropriate units."),
                    new SectionField("add-am-virus-route", "Virus Route", "multi-dropdown-pl", "VirusRouteIds", true, "pl-am-route")
                ]
            ),
            new Section("am-animal-section", "Animal Information",
                [
                    new SectionField("add-am-species", "Species", "dropdown-pl", "SpeciesId", true, "pl-am-species", "If the species does not appear in the list, please specify the species in the <span class='font-weight-500'>Additional Information</span> section."),
                    new SectionField("add-am-strain", "Animal Strain", "multi-dropdown-pl", "StrainIds", true, "pl-am-strain", "If the strain does not appear in the list, please specify the strain in the <span class='font-weight-500'>Additional Information</span> section."),
                    new SectionField("add-am-strain-details", "Animal Strain Details", "input-lg", "StrainDetails", false),
                    new SectionField("add-am-animal-source", "Animal Source", "multi-dropdown-pl", "SourceIds", true, "pl-am-source", "If the source does not appear in the list, please specify the source in the <span class='font-weight-500'>Additional Information</span> section."),
                    new SectionField("add-am-absl", "Animal Biosafety Level", "dropdown-pl", "AbslId", true, "pl-absl"),
                    new SectionField("add-am-animal-sex", "Animal Sex", "multi-dropdown-pl", "SexIds", true, "pl-am-sex"),
                    new SectionField("add-am-animal-age", "Animal Age Inclusion", "input-lg", "Age", false, "", "If applicable, indicate the age or age range."),
                    new SectionField("add-am-animal-weight", "Animal Weight Inclusion", "input-lg", "Weight", false, "", "If applicable, indicate the weight or weight range."),
                    new SectionField("add-am-endpoints", "Endpoint", "multi-dropdown-pl", "EndpointIds", true, "pl-am-endpoint"),
                    new SectionField("add-am-endpoint-details", "Endpoint Details", "input-lg", "EndpointDetails", false),
                ]
            ),
            new Section("am-developer-section", "Additional Information",
                [
                    new SectionField("add-am-positive-control", "Positive Control", "input-lg", "PositiveControl", false, "", "Describe any countermeasure positive control(s) used in this model and use parameters (route, dose and regimen, anticipated effects of the control)."),
                    new SectionField("add-am-pmids", "Publications", "new-list-selection-number", "PublicationIds", false, "", "Specify the PubMedId number (ex: 12345678) of any existing publications."),
                    new SectionField("add-am-protocol", "Protocol", "file-upload", "Protocol", false, "", "Please upload a <u>PDF version</u> of the protocol document associated with this animal model (Max 1 File Upload).", [["am-uploads"]]),
                    new SectionField("add-am-additional-info", "Additional Information", "input-lg", "AdditionalInfo", false),
                ]
            )
        ]

        this.addController = new AddNewController(this.id, this.title, "", this.sections, this.modalIdTarget);
    }

    initialize(pickLists: JsonItem[], defaultItem: any, description: string = ""): void {

        this.addController.initialize(pickLists, defaultItem);

        let modalContentTarget = $(`#${this.modalIdTarget}`);
        // Update Modal Title
        let htmlTitleContent = `
            <div>${this.title}</div>
        `
        if (description != "") {
            htmlTitleContent = `
                <div>${this.title}</div>
                <div class="font-size14 font-italic font-weight-500">${description}</div>
            `
        }
        modalContentTarget.find(".modal-title").empty().html(htmlTitleContent);

        // Update Modal Footer Button
        let htmlFooterContent = `<button class="greenbtn" type="button" onclick="page.${this.tableVarName}.saveAddModal()">Add New Animal Model!</button><span class="error-msg ml-5 text-danger font-weight-500" id="request-footer-error"></span>`;
        modalContentTarget.find(".modal-footer").empty().html(htmlFooterContent);
    }

    async save(): Promise<any> {
        let updatedItem = this.addController.getCurrentItem();
        let result: any;
        try {
            result = await $.ajax(this.submitRoute, {
                method: "POST",
                headers: { "RequestVerificationToken": <string>$('input[name="__RequestVerificationToken"]').val() },
                data: { data: JSON.stringify([updatedItem]) }
            });

            // Upload attachments after entity is saved in DB, so that we have ID
            if (this.addController.fileUploadFields.length > 0) {
                for (let i = 0; i < this.addController.fileUploadFields.length; i++) {
                    let fileUploadField = this.addController.fileUploadFields[i];
                    await fileUploadField.uploadAttachments(result);
                }
            }
            return result;
        }
        catch (error) {
            alert("An error has occurred, please refresh the page and try again.");
            console.log(error);
        }
    }

    showLoading(isLoading: boolean): void {
        this.addController.showLoading(isLoading);
    }

    showSaved(isSaved: boolean): void {
        this.addController.showSaved(isSaved);
    }

    getSelectedFilterTabId(): string {
        let selectedTab = $(`#${this.referenceId}-filter-tabs`).find(".active").first();
        return selectedTab.prop("id");
    }

    private additionalValidation(): boolean {
        let isValid: boolean = true;
        this.updateErrorText();

        let updatedItem: AnimalModel = this.addController.getCurrentItem();
        if (!updatedItem.ProjectIds && !updatedItem.CoreIds) {
            let generalSection = this.addController.sections.find(section => section.id == "am-general-section");
            let projectField = generalSection.fields.find(field => field.id == "add-am-project");
            let coreField = generalSection.fields.find(field => field.id == "add-am-core");

            this.updateErrorText("Please specify at least one core or project for this Animal Model.");
            projectField.displayValid(false);
            coreField.displayValid(false);
            isValid = false;
        }

        return isValid;
    }

    private updateErrorText(errorMsg: string = "") {
        let errorBlock = $(`#${this.modalIdTarget}`).find("#request-footer-error");
        errorBlock.text(errorMsg);
    }

    async saveAddModal(): Promise<void> {
        // if it isn't valid, don't save
        let isValid = this.addController.validate();
        if (!isValid) {
            this.updateErrorText("Please complete all required fields.")
            return;
        }

        let additionalValidation = this.additionalValidation();
        if (!additionalValidation) {
            return;
        }
        else {
            // show saving on edit modal
            this.addController.showLoading(true);

            // Get Current Filter Options
            let selectedTab: string = this.getSelectedFilterTabId();
            let currentFilterOptions: any[][] = this.parentTable.filterTabs.map(tab => {
                return tab.getSelectedValues();
            });

            // Get Current Sort
            let sortOrder: any[] = this.parentTable.getCurrentTableSort();

            // saves changes to DB (returns updated items)
            let result: any[] = await this.save();

            // reinitialze
            await this.parentTable.initialize()

            // Show Saved
            this.addController.showSaved(true);

            // Set Current Filter Options
            for (let i = 0; i < currentFilterOptions.length; i++) {
                let tabVals = currentFilterOptions[i];
                this.parentTable.filterTabs[i].setSelectedValues(tabVals);
            }
            $(`#${selectedTab}`).trigger("click");

            // Set Table Sort
            this.parentTable.setCurrentTableSort(sortOrder);

            // Scroll to New Item
            this.parentTable.scrollToAnimalModel();

            // hide loading/close modal
            setTimeout(() => {
                $(`#${this.modalIdTarget}`).modal('hide');

                // Don't hide information until after modal finishes hiding
                setTimeout(() => {
                    this.addController.showLoading(false);
                    this.addController.showSaved(false);
                }, 1000)
            }, 1000)
        }
    }
}